import * as React from 'react'
import styled, { css } from 'styled-components'
import theme from 'theme'
import { PageType } from '../../AccountDashboard'
import Link from 'theme/atoms/Link'
import ArrowLeft from 'assets/arrow-left.svg'
import useTranslations from 'hooks/useTranslations'

type Props = {
  activePage: PageType
}

export default function Dropdown(props: Props) {
  const t = useTranslations<'app-AccountDashboard'>()
  const [expanded, setExpanded] = React.useState(true)
  return (
    <Wrapper className="Dropdown" $expanded={expanded}>
      <div
        className="header"
        onClick={() => setExpanded(!expanded)}
        data-cy-handle="open-mobile-dropdown"
      >
        <div className="title">{t('dashboard_navigation_my_orders')}</div>
        <ArrowLeft />
      </div>
      <div className="links">
        <NavItem to="/online-service/" blank>
          {t('dashboard_online_service_2')}
        </NavItem>
        <NavItem to="/online-service/" blank>
          {t('dashboard_online_service_3')}
        </NavItem>
        <NavItem to="/online-service/" blank>
          {t('dashboard_online_service_4')}
        </NavItem>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $expanded: boolean }>`
  padding: ${theme.spacing('m')};
  background: ${theme.colors.shade.b7};
  > .header {
    ${theme.ty('rc-base')}
    margin-bottom: ${(p) => (p.$expanded ? theme.spacing('m') : '0')};
    transition: margin-bottom 0.1s ease-out;
    transition-delay: ${(p) => (p.$expanded ? '0' : '0.3s')};
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    > svg {
      width: 8px;
      transform: ${(p) => (p.$expanded ? 'rotate(90deg)' : 'rotate(270deg)')};
      transition: transform 0.3s ease-out;
    }
  }

  > .links {
    overflow: hidden;
    gap: ${theme.spacing('s')};
    flex-direction: column;
    display: flex;
    height: auto;
    max-height: ${(p) => (p.$expanded ? '300px' : '0')};
    transition: max-height 0.3s ease-out;
    ${(p) =>
      p.$expanded &&
      css`
        transition: max-height 0.3s ease-in;
      `}
  }
`

const NavItem = styled(Link)<{ $active?: boolean }>`
  ${theme.ty('rc-s')}
  color: ${(props) =>
    props.$active ? theme.colors.primary : theme.colors.shade.b2};
`
